import {Base} from "@/api/Base"

export class AnnualLeavePlanList extends Base {
    path = "annualLeavePlan/list"
}